import type { Props } from './types';

const useLogic = (props: Props) => {
    return {};
};

export default useLogic;
